import React from 'react';
import Breadcrumbs from '@shared/Widgets/Navigation/Breadcrumbs/Breadcrumbs';
import { BREADCRUMBS_LABELS } from '@configs/BreadcrumbsLabels';
import TemplatesView from '@modules/BillOfMaterials/Components/BillOfMaterials/TemplatesView/TemplatesView';

const TemplatesViewPage: React.FC = () => {
    return (
        <>
            <Breadcrumbs
                items={BREADCRUMBS_LABELS.TEMPLATES}
                key={'template-breadcrumbs'}
            />
            <TemplatesView />
        </>
    );
};

export default TemplatesViewPage;
